import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { LoadingSpinner } from '@/components/loading/Loading';
import { useAuth } from '@/libs/device-auth/hooks/useAuth';
import { AuthStateType } from '@/libs/device-auth';
import { AppScreen } from '@/types/common';

/**
 * PublicRoute is for unauthenticated users only
 * If the user is authenticated, redirect to GetStartedScreen
 * This component acts as a layout route that renders child routes via Outlet
 */
export const PublicRoute: React.FC = () => {
  const { isLoading, authStateType } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // If user is logged in, redirect to the get started flow
  if (authStateType === AuthStateType.AUTHENTICATED) {
    return <Navigate to={AppScreen.GET_STARTED} replace />;
  }

  // If user is not authenticated, show the public route
  return <Outlet />;
};
